import React from 'react';
import { Badge } from '../ui/badge';
import { getStatusClass } from '../../lib/utils';

export default function AdminTools({ tools }) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Verified Instruments
        </h2>
        <p className="text-sm text-zinc-500 mt-1">Assessment tools aligned to published standards.</p>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tool ID</th>
              <th>Name</th>
              <th>Standard</th>
              <th>Version</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {tools.map(tool => (
              <tr key={tool.id}>
                <td className="cert-id">{tool.id}</td>
                <td>{tool.name}</td>
                <td>{tool.standard_title}</td>
                <td>{tool.standard_version}</td>
                <td>
                  <Badge variant="outline" className={`rounded-none ${getStatusClass(tool.status)}`}>
                    {tool.status}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
